import { TaskchecklistsApi } from '../api-clients';
import { wrap } from '../wrap';

export const taskchecklistApi = {
  index: wrap(
    TaskchecklistsApi,
    TaskchecklistsApi.prototype.indexTaskChecklist
  ),
  create: wrap(
    TaskchecklistsApi,
    TaskchecklistsApi.prototype.createTaskChecklist
  ),
  update: wrap(
    TaskchecklistsApi,
    TaskchecklistsApi.prototype.updateTaskChecklist
  ),
  show: wrap(TaskchecklistsApi, TaskchecklistsApi.prototype.showTaskChecklist),
  delete: wrap(
    TaskchecklistsApi,
    TaskchecklistsApi.prototype.deleteTaskChecklist
  ),
};
